import { useState } from "react";
import ColorSchema from "../../kits/Color";
import { CloseIcon } from "../../kits/Icons";
import { CustomInput } from "../../kits/Inputs/Inputs";
import CustomButton from "../../kits/button/CustomButton";

export default function ChooseType({ changeAttributeData, data }) {
  const [newItem, setNewItem] = useState("");

  return (
    <div className="d-flex flex-wrap align-items-center mt-2">
      <div className=" d-flex align-items-center col-12 col-sm-6 col-md-5 col-lg-4 px-1">
        <CustomInput
          label="گزینه مورد نظر"
          inputSize="lg"
          type="text"
          inputType="input"
          inputContainer=""
          inputClassName=""
          inputValue={newItem}
          onChangeFunc={(e) => {
            setNewItem(e.target.value);
          }}
          // textErr={validationTxt.answers}
        />
        <div>
          <CustomButton
            color="success"
            size="small"
            //   type="outline"
            state="normal"
            circle={false}
            onClick={(e) => {
              if (newItem != "") {
                changeAttributeData(newItem, "newOption");
                setNewItem("");
              }
            }}
            className={"mt-4 ms-1"}
          >
            +
          </CustomButton>
        </div>
      </div>
      {data?.arrayListOption?.length > 0 && (
        <div className="ms-1 mt-1 ">
          <span style={{ fontSize: 14, fontWeight: "bold" }}>
            گزینه های وارد شده:
          </span>
          <div className="d-flex flex-wrap mt-2">
            {data?.arrayListOption?.map((value, index) => (
              <p
                className="ms-1 my-1 d-flex align-items-center p-2 rounded"
                style={{ backgroundColor: ColorSchema.success_light_custom }}
              >
                {value}
                <span
                  onClick={() => changeAttributeData(index, "deleteNewOption")}
                >
                  {" "}
                  <CloseIcon
                    containerIconClassName="ms-1"
                    color={ColorSchema.red_custom}
                    style={{ width: 18, height: 18, cursor: "pointer" }}
                  />
                </span>
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
